import { render, staticRenderFns } from "./LanguageOutput.vue?vue&type=template&id=b829a3f4&scoped=true&functional=true"
import script from "./LanguageOutput.vue?vue&type=script&lang=js"
export * from "./LanguageOutput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "b829a3f4",
  null
  
)

export default component.exports